import { SideDrawer, Button, TableChip } from '@/components';

export function MarketplaceEmailPreviewDrawer({
  isOpen,
  onClose,
  template,
  onUseTemplate,
  isUsing = false,
}) {
  if (!template) return null;

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      width="lg"
      showClose={false}
      headerClassName="!px-6 !py-5 border-b border-border-default/60"
      bodyClassName="p-4 sm:p-6 overflow-y-auto visible-scrollbar bg-layer-1-page/40"
      header={
        <div className="flex items-center justify-between w-full gap-3">
          <div className="flex flex-col text-left min-w-0">
            <h2 className="text-[18px] leading-[26px] font-semibold text-text-primary font-sf-pro-display truncate">
              {template.name}
            </h2>
            <p className="text-xs text-text-secondary truncate mt-0.5">
              Marketplace Email Template Preview
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Button
              variant="primary"
              onClick={() => onUseTemplate(template)}
              disabled={isUsing}
              isLoading={isUsing}
              className="h-[34px] px-3.5 text-xs font-semibold"
            >
              <span>Use Template</span>
            </Button>
            <button
              type="button"
              onClick={onClose}
              className="w-8 h-8 rounded-[8px] bg-primary text-white flex items-center justify-center hover:bg-primary-hover transition-colors focus:outline-none shrink-0"
              aria-label="Close"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                viewBox="0 0 24 24"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>
      }
    >
      <div className="flex flex-col gap-4 max-w-4xl mx-auto w-full">
        {/* Template Metadata Box */}
        <div className="bg-white rounded-xl border border-border-default/70 p-4 shadow-2xs space-y-3 font-sf-pro-display">
          <div className="flex flex-wrap items-center justify-between gap-2 border-b border-border-default/40 pb-2.5">
            <div className="flex items-center gap-2">
              <span className="text-xs text-text-muted font-medium">
                Industry:
              </span>
              <TableChip tone="neutral">
                {template.industry_name || template.industry?.name || 'General'}
              </TableChip>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs text-text-muted font-medium">
                Category:
              </span>
              <TableChip tone="primary" className="capitalize">
                {template.category || 'marketing'}
              </TableChip>
            </div>
          </div>

          <div className="flex flex-col gap-1 text-sm">
            <span className="text-xs text-text-muted font-medium">
              Subject Line
            </span>
            <div className="font-medium text-text-primary bg-layer-1-page/70 px-3 py-2 rounded-lg border border-border-default/50">
              {template.subject || '(No subject provided)'}
            </div>
          </div>

          {Array.isArray(template.variables) &&
            template.variables.length > 0 && (
              <div className="flex items-center gap-1.5 flex-wrap pt-1">
                <span className="text-xs text-text-muted font-medium">
                  Tags:
                </span>
                {template.variables.map((variable) => (
                  <span
                    key={variable}
                    className="px-2 py-0.5 rounded text-[11px] font-mono bg-blue-50 text-blue-700 border border-blue-200"
                  >
                    {`{{${variable}}}`}
                  </span>
                ))}
              </div>
            )}
        </div>

        {/* Email HTML Body Render */}
        <div className="flex flex-col gap-2">
          <span className="text-xs font-medium text-text-secondary px-1">
            Email Layout Preview
          </span>
          <div className="w-full bg-white shadow-sm border border-border-default/80 rounded-xl overflow-hidden min-h-[300px]">
            {template.body ? (
              <div
                className="w-full p-4 sm:p-6 overflow-x-auto"
                dangerouslySetInnerHTML={{ __html: template.body }}
              />
            ) : (
              <div className="py-20 text-center text-text-muted text-sm">
                No preview content available for this template.
              </div>
            )}
          </div>
        </div>
      </div>
    </SideDrawer>
  );
}
